
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica",
      function () {
        return require("private-next-pages/politica/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politica"])
      });
    }
  